export const GRAPHQL_MUTATION = {
    hrmInsertHrtbWorkerAttachment: {
        query:
            "mutation hrmInsertHrtbWorkerAttachment($objects: [hrm_hrtb_worker_attachment_insert_input!] = {}) { data: insert_hrm_hrtb_worker_attachment(objects: $objects) { affected_rows returning { aggId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerAttachment: {
        query: `
        mutation hrmUpdateHrtbWorkerAttachment($_set: hrm_hrtb_worker_attachment_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_attachment(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerAttachmentNotUsingFlg: {
        query: `
        mutation hrmUpdateHrtbWorkerAttachmentNotUsingFlg($_set: hrm_hrtb_worker_attachment_set_input = {}, $_eq: numeric = "", $_eq1: numeric = "", $_eq2: String = "") {
            data: update_hrm_hrtb_worker_attachment(_set: $_set, where: {usingFlg: {_eq: "1"}, workerId: {_eq: $_eq}, attachmentTypeId: {_eq: $_eq1}, _not: {attachmentRefno: {_eq: $_eq2}}}) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_eq1", "_eq2", "_set"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_STUDENT",
        ],
        function: [],
    },
    hrmInsertHrtbWorkerQualifyAttachment: {
        query:
            "mutation hrmInsertHrtbWorkerQualifyAttachment($objects: [hrm_hrtb_worker_qualify_attachment_insert_input!] = {}) { data: insert_hrm_hrtb_worker_qualify_attachment(objects: $objects) { returning { id } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerQualifyAttachment: {
        query: `
        mutation hrmDeleteHrtbWorkerQualifyAttachment($_eq: String = "") {
            delete_hrm_hrtb_worker_qualify_attachment(where: {attachmentRefno: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorker: {
        query: `
        mutation hrmInsertHrtbWorker($objects: [hrm_hrtb_worker_insert_input!] = {}) {
            data: insert_hrm_hrtb_worker(objects: $objects) {
                affected_rows
                returning {
                    aggId
                    id
                    qualifications: hrtb_worker_qualifications {
                        aggId
                    }
                    candidate: hrtb_candidates {
                        id
                        aggId
                        resumes: hrtb_candidate_resumes {
                            id
                            aggId
                            recommenders: hrtb_candidate_recommenders {
                                aggId
                            }
                        }
                    }
                }
            }
        }`,
        variables: ["objects"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_STUDENT",
        ],
        function: [],
    },
    hrmUpdateHrtbWorker: {
        query: `
        mutation hrmUpdateHrtbWorker($_set: hrm_hrtb_worker_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_STUDENT",
        ],
        function: [],
    },
    hrmUpdateHrtbCandidate: {
        query: `
        mutation hrmUpdateHrtbCandidate($_set: hrm_hrtb_candidate_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_candidate(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbCandidateByAggIds: {
        query: `
        mutation hrmUpdateHrtbCandidateByAggIds($_set: hrm_hrtb_candidate_set_input = {}, $_in: [uuid!] = []) {
            data: update_hrm_hrtb_candidate(where: {aggId: {_in: $_in}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_in", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbCandidateById: {
        query: `
        mutation hrmUpdateHrtbCandidateById($_set: hrm_hrtb_candidate_set_input = {}, $_eq: numeric = "") {
            data: update_hrm_hrtb_candidate(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertHrtbWorkerAddress: {
        query:
            "mutation hrmInsertHrtbWorkerAddress($objects: [hrm_hrtb_worker_address_insert_input!] = {}) { data: insert_hrm_hrtb_worker_address(objects: $objects) { affected_rows returning { aggId id } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerAddressList: {
        query:
            "mutation hrmInsertHrtbWorkerAddressList($objects: [hrm_hrtb_worker_address_insert_input!] = []) { data: insert_hrm_hrtb_worker_address(objects: $objects) { affected_rows returning { aggId id } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerAddress: {
        query: `
        mutation hrmUpdateHrtbWorkerAddress($_set: hrm_hrtb_worker_address_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_address(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE", "SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteHrtbWorkerAddress: {
        query: `
        mutation hrmDeleteHrtbWorkerAddress($_eq: uuid = "") {
            data: delete_hrm_hrtb_worker_address(where: {_or: [{aggId: {_eq: $_eq}}, {hrtb_worker: {aggId: {_eq: $_eq}}}]}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerAddressById: {
        query: `
        mutation hrmDeleteHrtbWorkerAddressById($_eq: numeric = "") {
            data: delete_hrm_hrtb_worker_address(where: {id: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteHrtbWorkerLegaldoc: {
        query: `
        mutation hrmDeleteHrtbWorkerLegaldoc($_eq: numeric = "") {
            delete_hrm_hrtb_worker_legaldoc(where: {id: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteHrtbWorkerAttachmentByIds: {
        query: `
        mutation hrmDeleteHrtbWorkerAttachmentByIds($_in: [numeric!] = []) {
            delete_hrm_hrtb_worker_attachment(where: {id: {_in: $_in}}) {
                affected_rows
            }
        }`,
        variables: ["_in"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertHrtbWorkerQualification: {
        query:
            "mutation hrmInsertHrtbWorkerQualification($objects: [hrm_hrtb_worker_qualification_insert_input!] = {}) { data: insert_hrm_hrtb_worker_qualification(objects: $objects) { affected_rows returning { aggId id attachments: hrtb_worker_qualify_attachments { aggId id } } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerQualification: {
        query: `
        mutation hrmUpdateHrtbWorkerQualification($_set: hrm_hrtb_worker_qualification_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_qualification(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                aggId
                    attachment: hrtb_worker_qualify_attachments {
                        attachmentRefno
                        extraInfo
                    }
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerQualificationByWorkerId: {
        query: `
        mutation hrmUpdateHrtbWorkerQualificationByWorkerId($_set: hrm_hrtb_worker_qualification_set_input = {}, $_eq: numeric = "") {
            data: update_hrm_hrtb_worker_qualification(where: {workerId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                aggId
                    attachment: hrtb_worker_qualify_attachments {
                        attachmentRefno
                        extraInfo
                    }
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbCandidateRecommender: {
        query:
            "mutation hrmInsertHrtbCandidateRecommender($objects: [hrm_hrtb_candidate_recommender_insert_input!] = {}) { data: insert_hrm_hrtb_candidate_recommender(objects: $objects) { affected_rows returning { id aggId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbCandidateRecommender: {
        query: `
        mutation hrmUpdateHrtbCandidateRecommender($_set: hrm_hrtb_candidate_recommender_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_candidate_recommender(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbRequisitionRecommender: {
        query: `
        mutation hrmUpdateRstbRequisitionRecommender($_set: recruit_rstb_requisition_recommender_set_input = {}, $_eq: uuid = "") {
            data: update_recruit_rstb_requisition_recommender(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_CORE_RRM_ERP_PAYMENT"],
        function: [],
    },
    hrmInsertHrtbWorkerLegaldoc: {
        query:
            "mutation hrmInsertHrtbWorkerLegaldoc($objects: [hrm_hrtb_worker_legaldoc_insert_input!] = {}) { data: insert_hrm_hrtb_worker_legaldoc(objects: $objects) { affected_rows returning { aggId id } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerLegaldoc: {
        query: `
        mutation hrmUpdateHrtbWorkerLegaldoc($_set: hrm_hrtb_worker_legaldoc_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_legaldoc(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerSummary: {
        query: `
        mutation hrmDeleteHrtbWorkerSummary($_eq: uuid = "") {
            data: delete_hrm_hrtb_worker_summary(where: {_or: [{aggId: {_eq: $_eq}}, {hrtb_worker: {aggId: {_eq: $_eq}}}]}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerSummaryWithSummaryType: {
        query: `
        mutation hrmDeleteHrtbWorkerSummaryWithSummaryType($_eq: uuid = "", $_eq1: uuid = "") {
            data: delete_hrm_hrtb_worker_summary(where: {hrtb_worker: {aggId: {_eq: $_eq}}, hrtm_summary_type: {aggId: {_eq: $_eq1}}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_eq1"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerSummary: {
        query:
            "mutation hrmInsertHrtbWorkerSummary($objects: [hrm_hrtb_worker_summary_insert_input!] = {}) { data: insert_hrm_hrtb_worker_summary(objects: $objects) { affected_rows returning { id aggId updateId updateDate makerDate makerId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerSummaryList: {
        query:
            "mutation hrmInsertHrtbWorkerSummaryList($objects: [hrm_hrtb_worker_summary_insert_input!] = []) { data: insert_hrm_hrtb_worker_summary(objects: $objects) { affected_rows returning { id aggId updateId updateDate makerDate makerId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerSummary: {
        query: `
        mutation hrmUpdateHrtbWorkerSummary($_set: hrm_hrtb_worker_summary_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_summary(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerSocial: {
        query: `
        mutation hrmDeleteHrtbWorkerSocial($_eq: uuid = "") {
            data: delete_hrm_hrtb_worker_social(where: {_or: [{aggId: {_eq: $_eq}}, {hrtb_worker: {aggId: {_eq: $_eq}}}]}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerSocial: {
        query: `
        mutation hrmUpdateHrtbWorkerSocial($_set: hrm_hrtb_worker_social_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_social(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerSocial: {
        query:
            "mutation hrmInsertHrtbWorkerSocial($objects: [hrm_hrtb_worker_social_insert_input!] = {}) { data: insert_hrm_hrtb_worker_social(objects: $objects) { affected_rows returning { aggId makerDate makerId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerSocialList: {
        query:
            "mutation hrmInsertHrtbWorkerSocialList($objects: [hrm_hrtb_worker_social_insert_input!] = []) { data: insert_hrm_hrtb_worker_social(objects: $objects) { affected_rows returning { aggId makerDate makerId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbCandidateResume: {
        query:
            "mutation hrmInsertHrtbCandidateResume($objects: [hrm_hrtb_candidate_resume_insert_input!] = {}) { data: insert_hrm_hrtb_candidate_resume(objects: $objects) { affected_rows returning { aggId recommenders: hrtb_candidate_recommenders { aggId } } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbCandidateResume: {
        query: `
        mutation hrmUpdateHrtbCandidateResume($_set: hrm_hrtb_candidate_resume_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_candidate_resume(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                    recommenders: hrtb_candidate_recommenders {
                        aggId
                    }
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerRecord: {
        query:
            "mutation hrmInsertHrtbWorkerRecord($objects: [hrm_hrtb_worker_record_insert_input!] = {}) { data: insert_hrm_hrtb_worker_record(objects: $objects) { affected_rows returning { aggId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerRecordList: {
        query:
            "mutation hrmInsertHrtbWorkerRecordList($objects: [hrm_hrtb_worker_record_insert_input!] = []) { data: insert_hrm_hrtb_worker_record(objects: $objects) { affected_rows returning { aggId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerRecord: {
        query: `
        mutation hrmUpdateHrtbWorkerRecord($_set: hrm_hrtb_worker_record_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_record(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmDeleteHrtbWorkerRecord: {
        query: `
        mutation hrmDeleteHrtbWorkerRecord($_eq: uuid = "") {
            data: delete_hrm_hrtb_worker_record(where: {_or: [{aggId: {_eq: $_eq}}, {hrtb_worker: {aggId: {_eq: $_eq}}}]}) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbWorkerRefperson: {
        query:
            "mutation hrmInsertHrtbWorkerRefperson($objects: [hrm_hrtb_worker_refperson_insert_input!] = {}) { data: insert_hrm_hrtb_worker_refperson(objects: $objects) { affected_rows returning { id aggId } } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerRefperson: {
        query: `
        mutation hrmUpdateHrtbWorkerRefperson($_set: hrm_hrtb_worker_refperson_set_input = {}, $_eq: uuid = "") {
            data: update_hrm_hrtb_worker_refperson(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbWorkerReferenceCheck: {
        query: `
        mutation hrmUpdateHrtbWorkerReferenceCheck($_set: recruit_rstb_reference_check_set_input = {}, $_eq: uuid = "") {
            data: update_recruit_rstb_reference_check(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateCstbCandidate: {
        query: `
        mutation hrmUpdateCstbCandidate($_set: connect_cstb_candidate_set_input = {}, $_eq: uuid = "") {
            data: update_connect_cstb_candidate(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateCstbCandidateByAggIds: {
        query: `
        mutation hrmUpdateCstbCandidateByAggIds($_set: connect_cstb_candidate_set_input = {}, $_in: [uuid!] = []) {
            data: update_connect_cstb_candidate(where: {aggId: {_in: $_in}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_in", "_set"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateCstbCandidateResume: {
        query: `
        mutation hrmUpdateCstbCandidateResume($_set: connect_cstb_candidate_resume_set_input = {}, $_eq: numeric = "") {
            data: update_connect_cstb_candidate_resume(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateCstbCandidateResumeByIds: {
        query: `
        mutation hrmUpdateCstbCandidateResumeByIds($_set: connect_cstb_candidate_resume_set_input = {}, $_in: [numeric!] = []) {
            data: update_connect_cstb_candidate_resume(where: {id: {_in: $_in}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_in", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbCandidateGroup: {
        query:
            "mutation hrmInsertHrtbCandidateGroup($objects: [hrm_hrtb_candidate_group_insert_input!] = {}) { data: insert_hrm_hrtb_candidate_group(objects: $objects) { affected_rows } }",
        variables: ["objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbSavedDetail: {
        query: `
        mutation hrmUpdateRstbSavedDetail($_set: recruit_rstb_saved_detail_set_input = {}, $_eq: String = "", $_eq1: numeric = "", $_eq2: numeric = "") {
            data: update_recruit_rstb_saved_detail(where: {recordStatus: {_eq: $_eq}, _or: [{candidateId: {_eq: $_eq1}}, {onlineCandidateId: {_eq: $_eq2}}]}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_eq1", "_eq2", "_set"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateHrtbCgroupDetail: {
        query: `
        mutation hrmUpdateHrtbCgroupDetail($_set: hrm_hrtb_cgroup_detail_set_input = {}, $objects: [hrm_hrtb_cgroup_detail_insert_input!] = {}, $_eq: numeric = "") {
            update_hrm_hrtb_cgroup_detail(_set: $_set, where: {candidateGroupId: {_eq: $_eq}}) {
                affected_rows
            }
            insert_hrm_hrtb_cgroup_detail(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set", "objects"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbCandidateWithWorkerQualificationSummary: {
        query: `
        mutation hrmInsertHrtbCandidateWithWorkerQualificationSummary($objects: [hrm_hrtb_candidate_insert_input!] = {}, $objects1: [hrm_hrtb_worker_qualification_insert_input!] = {}, $objects2: [hrm_hrtb_worker_summary_insert_input!] = [], , $objects3: [hrm_hrtb_worker_social_insert_input!] = []) {
            insert_hrm_hrtb_candidate(objects: $objects) {
                affected_rows
                returning {
                    aggId
                    code
                }
            }
            insert_hrm_hrtb_worker_qualification(objects: $objects1) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
            insert_hrm_hrtb_worker_summary(objects: $objects2) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
            insert_hrm_hrtb_worker_social(objects: $objects3) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["objects", "objects1", "objects2"],
        screen: ["SCREEN_RRM_CANDIDATE", "SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertHrtbCandidate: {
        query: `
        mutation hrmInsertHrtbCandidate($objects: [hrm_hrtb_candidate_insert_input!] = {}) {
            candidate: insert_hrm_hrtb_candidate(objects: $objects) {
                affected_rows
                returning {
                    id
                    aggId
                    code
                }
            }
        }`,
        variables: ["objects", "objects1", "objects2"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertPstmEmailTemplate: {
        query:
            "mutation hrmInsertPstmEmailTemplate($objects: [recruit_pstm_email_template_insert_input!] = {}) { insert_recruit_pstm_email_template(objects: $objects) { affected_rows } }",
        variables: ["objects"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_CORE_RRM_ERP_PAYMENT",
            "SCREEN_RRM_STUDENT",
        ],
        function: [],
    },
    hrmUpdatePstmEmailTemplate: {
        query: `
        mutation hrmUpdatePstmEmailTemplate($_set: recruit_pstm_email_template_set_input = {}, $_eq: uuid = "") {
            update_recruit_pstm_email_template(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_CORE_RRM_ERP_PAYMENT",
            "SCREEN_RRM_STUDENT",
        ],
        function: [],
    },
    hrmInsertRstbRequisitionDraft: {
        query: `
        mutation hrmInsertRstbRequisitionDraft($objects: [recruit_rstb_requisition_draft_insert_input!] = {}) {
            insert_recruit_rstb_requisition_draft(objects: $objects) {
                returning {
                    aggId
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmUpdateRstbRequisitionDraft: {
        query: `
        mutation hrmUpdateRstbRequisitionDraft($_set: recruit_rstb_requisition_draft_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_requisition_draft(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmDeleteRstbRequisitionDraft: {
        query: `
        mutation hrmDeleteRstbRequisitionDraft($_eq: numeric = "") {
            delete_recruit_rstb_requisition_draft(where: {id: {_eq: $_eq}}) {
                returning {
                    id
                }
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmInsertConnectCstbPosting: {
        query: `
        mutation hrmInsertConnectCstbPosting($objects: [connect_cstb_posting_insert_input!]!) {
            data: insert_connect_cstb_posting(objects: $objects) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmUpdateConnectCstbPosting: {
        query: `
        mutation hrmUpdateConnectCstbPosting($_set: connect_cstb_posting_set_input = {}, $_eq: uuid = "") {
            data: update_connect_cstb_posting(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmInsertConnectCstbPostingChannel: {
        query: `
        mutation hrmInsertConnectCstbPostingChannel($objects: [connect_cstb_posting_channel_insert_input!] = {}) {
            insert_connect_cstb_posting_channel(objects: $objects) {
                returning {
                    aggId
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmDeleteConnectCstbPostingChannel: {
        query: `
        mutation hrmDeleteConnectCstbPostingChannel($_eq: uuid = "") {
            data: delete_connect_cstb_posting_channel(where: {aggId: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_TRACKING"],
        function: [],
    },
    hrmInsertRstbRequisitionCandidateForJobApply: {
        query: `
        mutation hrmInsertRstbRequisitionCandidateForJobApply($_set: hrm_hrtb_candidate_set_input = {}, $objects: [recruit_rstb_requisition_candidate_insert_input!] = {}, $_eq: uuid = "") {
            data: insert_recruit_rstb_requisition_candidate(objects: $objects) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }    
            updateCandidate: update_hrm_hrtb_candidate(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["objects", "_eq", "set"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmInsertRstbRequisitionAttachment: {
        query: `
        mutation hrmInsertRstbRequisitionAttachment($objects: [recruit_rstb_requisition_attachment_insert_input!] = {}) {
            data: insert_recruit_rstb_requisition_attachment(objects: $objects) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbRequisitionJob: {
        query: `
        mutation hrmUpdateRstbRequisitionJob($_set: recruit_rstb_requisition_job_set_input = {}, $_eq: uuid = "") {
            data: update_recruit_rstb_requisition_job(_set: $_set, where: {aggId: {_eq: $_eq}}) {
                affected_rows
                returning {
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbRequisitionByCode: {
        query: `
        mutation hrmUpdateRstbRequisitionByCode($_set: recruit_rstb_requisition_set_input = {}, $_eq: String = "") {
            data: update_recruit_rstb_requisition(where: {code: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_ONLINE_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbRequisitionById: {
        query: `
        mutation hrmUpdateRstbRequisitionById($_set: recruit_rstb_requisition_set_input = {}, $_eq: numeric = "") {
            data: update_recruit_rstb_requisition(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionByIds: {
        query: `
        mutation hrmUpdateRstbRequisitionByIds($_set: recruit_rstb_requisition_set_input = {}, $_in: [numeric!] = []) {
            data: update_recruit_rstb_requisition(where: {id: {_in: $_in}}, _set: $_set) {
                affected_rows
                returning {
                    id
                    aggId
                }
            }
        }`,
        variables: ["_in", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbTracking: {
        query: `
        mutation hrmInsertRstbTracking($objects: [recruit_rstb_tracking_insert_input!] = []) {
            insert_recruit_rstb_tracking(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbAssignmentAttachment: {
        query: `
        mutation hrmInsertRstbAssignmentAttachment($objects: [recruit_rstb_assignment_attachment_insert_input!] = {}) {
            insert_recruit_rstb_assignment_attachment(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbAssignment: {
        query: `
        mutation hrmInsertRstbAssignment($objects: [recruit_rstb_assignment_insert_input!] = {}) {
            data: insert_recruit_rstb_assignment(objects: $objects) {
                returning {
                    aggId
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbAssessmentScreening: {
        query: `
        mutation hrmInsertRstbAssessmentScreening($objects: [recruit_rstb_assessment_screening_insert_input!] = {}) {
            insert_recruit_rstb_assessment_screening(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbRequisitionApproval: {
        query: `
        mutation hrmInsertRstbRequisitionApproval($objects: [recruit_rstb_requisition_approval_insert_input!] = []) {
            insert_recruit_rstb_requisition_approval(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstdRequisitionOffer: {
        query: `
        mutation hrmInsertRstdRequisitionOffer($objects: [recruit_rstd_requisition_offer_insert_input!] = {}) {
            insert_recruit_rstd_requisition_offer(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbRequisitionOffer: {
        query: `
        mutation hrmInsertRstbRequisitionOffer($objects: [recruit_rstb_requisition_offer_insert_input!] = {}) {
            insert_recruit_rstb_requisition_offer(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbInterview: {
        query: `
        mutation hrmInsertRstbInterview($objects: [recruit_rstb_interview_insert_input!] = {}) {
            insert_recruit_rstb_interview(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertRstbRequisitionCandidateForMatching: {
        query: `
        mutation hrmInsertRstbRequisitionCandidateForMatching($_in: [numeric!] = [], $status: String = "", $objectCandidates: [recruit_rstb_requisition_candidate_insert_input!] = [], $objectAttachments: [recruit_rstb_requisition_attachment_insert_input!] = []) {
            updateCandidate: update_hrm_hrtb_candidate(where: {id: {_in: $_in}}, _set: {status: $status}) {
                affected_rows
            }
            insertRequisitionCandidate: insert_recruit_rstb_requisition_candidate(objects: $objectCandidates) {
                affected_rows
            }
            insertRequisitionAttachment: insert_recruit_rstb_requisition_attachment(objects: $objectAttachments) {
                affected_rows
            }
        }`,
        variables: ["_in", "status", "objectCandidates", "objectAttachments"],
        screen: ["SCREEN_RRM_TASK", "SCREEN_RRM_CANDIDATE"],
        function: [],
    },
    hrmUpdateRstbAssessmentInterview: {
        query: `
        mutation hrmUpdateRstbAssessmentInterview($_set: recruit_rstb_assessment_interview_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_assessment_interview(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbInterview: {
        query: `
        mutation hrmUpdateRstbInterview($_set: recruit_rstb_interview_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_interview(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstdRequisitionOffer: {
        query: `
        mutation hrmUpdateRstdRequisitionOffer($_set: recruit_rstd_requisition_offer_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstd_requisition_offer(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionOffer: {
        query: `
        mutation hrmUpdateRstbRequisitionOffer($_set: recruit_rstb_requisition_offer_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_requisition_offer(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmInsertKstbGoal: {
        query: `
        mutation hrmInsertKstbGoal($objects: [kpi_kstb_goal_insert_input!] = []) {
            data: insert_kpi_kstb_goal(objects: $objects) {
                returning {
                    id
                    kstb_goal_assignments {
                        id
                    }
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbAssessmentScreening: {
        query: `
        mutation hrmUpdateRstbAssessmentScreening($_set: recruit_rstb_assessment_screening_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_assessment_screening(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbAssignment: {
        query: `
        mutation hrmUpdateRstbAssignment($_set: recruit_rstb_assignment_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_assignment(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteRstbAssignment: {
        query: `
        mutation hrmDeleteRstbAssignment($_eq: numeric = "") {
            delete_recruit_rstb_assignment(where: {id: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteRstbAssignmentAttachment: {
        query: `
        mutation hrmDeleteRstbAssignmentAttachment($_in: [numeric!] = []) {
            delete_recruit_rstb_assignment_attachment(where: {id: {_in: $_in}}) {
                affected_rows
            }
        }`,
        variables: ["_in"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmDeleteRstbTracking: {
        query: `
        mutation hrmDeleteRstbTracking($_in: [numeric!] = []) {
            delete_recruit_rstb_tracking(where: {id: {_in: $_in}}) {
                affected_rows
            }
        }`,
        variables: ["_in"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateCandidateIdentity: {
        query: `
        mutation hrmUpdateCandidateIdentity($_set: hrm_hrtb_worker_set_input = {}, $_setCandidate: hrm_hrtb_candidate_set_input = {}, $objectLegalDoc: [hrm_hrtb_worker_legaldoc_insert_input!] = {}, $objectAttachments: [hrm_hrtb_worker_attachment_insert_input!] = [], $_eq: numeric = "", $_eq1: numeric = "") {
            update_hrm_hrtb_worker(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
            update_hrm_hrtb_candidate(where: {id: {_eq: $_eq1}}, _set: $_setCandidate) {
                affected_rows
            }
            insert_hrm_hrtb_worker_legaldoc(objects: $objectLegalDoc) {
                affected_rows
            }
            insert_hrm_hrtb_worker_attachment(objects: $objectAttachments) {
                affected_rows
            }
        }`,
        variables: [
            "_eq",
            "_set",
            "_eq1",
            "_setCandidate",
            "objectLegalDoc",
            "objectAttachments",
        ],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateReopenCandidateNotStart: {
        query: `
        mutation hrmUpdateReopenCandidateNotStart($_set: recruit_rstb_requisition_candidate_set_input = {}, $_set1: hrm_hrtb_candidate_set_input = {}, $_in: [numeric!] = [], $_in1: [numeric!] = []) {
            update_recruit_rstb_requisition_candidate(where: {id: {_in: $_in}}, _set: $_set) {
                affected_rows
            }
            update_hrm_hrtb_candidate(where: {id: {_in: $_in1}}, _set: $_set1) {
                affected_rows
            }
        }`,
        variables: ["_in", "_set", "_in1", "_set1"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbInterviewForBooking: {
        query: `
        mutation hrmUpdateRstbInterviewForBooking($_setInterview: recruit_rstb_interview_set_input = {}, $objectInterviewers: [recruit_rstb_assessment_interview_insert_input!] = {}, $_eq: numeric = "") {
            update_recruit_rstb_interview(where: {id: {_eq: $_eq}}, _set: $_setInterview) {
                affected_rows
            }
            delete_recruit_rstb_assessment_interview(where: {interviewId: {_eq: $_eq}}) {
                affected_rows
            }
            insert_recruit_rstb_assessment_interview(objects: $objectInterviewers) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_setInterview", "objectInterviewers"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionCandidate: {
        query: `
        mutation hrmUpdateRstbRequisitionCandidate($_set: recruit_rstb_requisition_candidate_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_requisition_candidate(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionCandidateByIds: {
        query: `
        mutation hrmUpdateRstbRequisitionCandidateByIds($_set: recruit_rstb_requisition_candidate_set_input = {}, $_in: [numeric!] = []) {
            update_recruit_rstb_requisition_candidate(where: {id: {_in: $_in}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_in"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionCandidateByTaskId: {
        query: `
        mutation hrmUpdateRstbRequisitionCandidateByTaskId($_set: recruit_rstb_requisition_candidate_set_input = {}, $_eq: String = "") {
            update_recruit_rstb_requisition_candidate(where: {taskId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateRstbRequisitionCandidateByTaskIds: {
        query: `
        mutation hrmUpdateRstbRequisitionCandidateByTaskIds($_set: recruit_rstb_requisition_candidate_set_input = {}, $_in: [String!] = []) {
            update_recruit_rstb_requisition_candidate(where: {taskId: {_in: $_in}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_in"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateCstbProfile: {
        query: `
        mutation hrmUpdateCstbProfile($_set: connect_cstb_profile_set_input = {}, $_eq: uuid = "") {
            update_connect_cstb_profile(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROFILE"],
        function: [],
    },
    hrmUpdateSmtbUserSocialStatus: {
        query: `
        mutation hrmUpdateSmtbUserSocialStatus($_set: connect_smtb_user_social_status_set_input = {}, $_eq: String = "") {
            update_connect_smtb_user_social_status(where: {userCode: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROFILE"],
        function: [],
    },
    hrmInsertRstbSavedList: {
        query: `
        mutation hrmInsertRstbSavedList($objects: [recruit_rstb_saved_list_insert_input!] = {}) {
            insert_recruit_rstb_saved_list(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmUpdateRstbSavedList: {
        query: `
        mutation hrmUpdateRstbSavedList($_set: recruit_rstb_saved_list_set_input = {}, $_eq: uuid = "") {
            update_recruit_rstb_saved_list(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmUpdateRstbSavedListById: {
        query: `
        mutation hrmUpdateRstbSavedListById($_set: recruit_rstb_saved_list_set_input = {}, $_eq: numeric = "") {
            update_recruit_rstb_saved_list(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmInsertRstbSavedDetail: {
        query: `
        mutation hrmInsertRstbSavedDetail($objects: [recruit_rstb_saved_detail_insert_input!] = []) {
            insert_recruit_rstb_saved_detail(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmDeleteRstbSavedDetail: {
        query: `
        mutation hrmDeleteRstbSavedDetail($_savedListId: numeric = "", $_ids: [numeric!] = []) {
            delete_recruit_rstb_saved_detail(where: {savedListId: {_eq: $_savedListId}, candidateId: {_in: $_ids}}) {
                affected_rows
            }
        }`,
        variables: ["_savedListId", "_ids"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmDeleteRstbSavedDetailWhereAnd: {
        query: `
        mutation hrmDeleteRstbSavedDetailWhereAnd($_savedListId: numeric = "", $_ids: [numeric!] = "", $_idsOnline: [numeric!] = []) {
            delete_recruit_rstb_saved_detail(where: {_and: [{savedListId: {_eq: $_savedListId}}, {_or: [{onlineCandidateId: {_in: $_idsOnline}}, {candidateId: {_in: $_ids}}]}]}) {
                affected_rows
            }
        }`,
        variables: ["_savedListId", "_ids", "_idsOnline"],
        screen: [
            "SCREEN_RRM_CANDIDATE",
            "SCREEN_RRM_ONLINE_CANDIDATE",
            "SCREEN_RRM_SAVED_CANDIDATE",
        ],
        function: [],
    },
    hrmUpdatePstbEventRecordStatus: {
        query: `
        mutation hrmUpdatePstbEventRecordStatus($_eq: uuid = "", $_set: recruit_pstb_event_set_input = {}) {
            update_recruit_pstb_event(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                returning {
                    id
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmUpdatePstbEventParticipant: {
        query: `
        mutation hrmUpdatePstbEventParticipant($_eq: numeric = "", $_set: recruit_pstb_event_participant_set_input = {}) {
            data: update_recruit_pstb_event_participant(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmUpdatePstbEventParticipantChecking: {
        query: `
        mutation hrmUpdatePstbEventParticipantChecking($_in: [numeric!] = [], $_set: recruit_pstb_event_participant_set_input = {}) {
            data: update_recruit_pstb_event_participant(where: {id: {_in: $_in}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_in", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmUpdatePstbEventParticipantSession: {
        query: `
        mutation hrmUpdatePstbEventParticipantSession($_set: recruit_pstb_event_participant_set_input = {}, $_eq: uuid = "") {
            data: update_recruit_pstb_event_participant(where: {pstb_event: {aggId: {_eq: $_eq}}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_EVENT"],
        function: [],
    },
    hrmUpdateRstbExclusionDetail: {
        query: `
        mutation hrmUpdateRstbExclusionDetail($_eq: uuid = "", $_set: recruit_rstb_exclusion_detail_set_input = {}) {
            update_recruit_rstb_exclusion_detail(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_CORE_RRM_ERP_EXCLUSION"],
        function: [],
    },

    hrmInsertRecruitPstbField: {
        query: `
        mutation hrmInsertRecruitPstbField($objects: [recruit_pstb_field_insert_input!] = {}) {
            insert_recruit_pstb_field(objects: $objects) {
                returning {
                    id
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_PROGRAM_FIELD"],
        function: [],
    },
    hrmUpdateRecruitPstbField: {
        query: `
        mutation hrmUpdateRecruitPstbField($_eq: uuid = "", $_set: recruit_pstb_field_set_input = {}) {
            update_recruit_pstb_field(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_FIELD"],
        function: [],
    },
    hrmUpdateRecruitPstbFieldRecordStatus: {
        query: `
        mutation hrmUpdateRecruitPstbFieldRecordStatus($_eq: uuid = "", $_set: recruit_pstb_field_set_input = {}) {
            update_recruit_pstb_field(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                returning {
                    id
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_FIELD"],
        function: [],
    },
    hrmChangePrimaryGroupCandidate: {
        query: `
        mutation hrmChangePrimaryGroupCandidate($_candidateGroupId: numeric = "", $_candidateId: numeric = "", $_set1: hrm_hrtb_cgroup_detail_set_input = {}, $_set2: hrm_hrtb_cgroup_detail_set_input = {}) {
            updateAllGrouptoZero: update_hrm_hrtb_cgroup_detail(_set: $_set1, where: {candidateGroupId: {_eq: $_candidateGroupId}}) {
                affected_rows
            }
            updateRowSelectPrimary: update_hrm_hrtb_cgroup_detail(_set: $_set2, where: {_and: {candidateGroupId: {_eq: $_candidateGroupId}, candidateId: {_eq: $_candidateId}}}) {
                affected_rows
            }
        }`,
        variables: ["_candidateGroupId", "_candidateId", "_set1", "_set2"],
        screen: ["SCREEN_RRM_CANDIDATE_GROUP"],
        function: [],
    },
    hrmInsertRecruitgstbGift: {
        query: `
        mutation hrmInsertRecruitgstbGift($objects: [recruit_gstb_gift_insert_input!] = {}) {
            insert_recruit_gstb_gift(objects: $objects) {
                returning {
                    id
                }
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_PROGRAM_GIFTS"],
        function: [],
    },
    hrmUpdateRecruitgstbGift: {
        query: `
        mutation hrmUpdateRecruitgstbGift($_eq: uuid = "", $_set: recruit_gstb_gift_set_input = {}) {
            update_recruit_gstb_gift(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                returning {
                    id
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_GIFTS"],
        function: [],
    },
    hrmInsertRecruitgstbQuestion: {
        query: `
        mutation hrmInsertRecruitgstbQuestion($objects: [recruit_qstb_question_insert_input!] = {}) {
            insert_recruit_qstb_question(objects: $objects) {
                affected_rows
            }
        }`,
        variables: ["objects"],
        screen: ["SCREEN_RRM_PROGRAM_QUESTION"],
        function: [],
    },
    hrmUpdateRecruitgstbQuestion: {
        query: `
        mutation hrmUpdateRecruitgstbQuestion($_eq: uuid = "", $_set: recruit_qstb_question_set_input = {}) {
            update_recruit_qstb_question(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_PROGRAM_QUESTION"],
        function: [],
    },
    hrmUpdateRecruitQstmQuestionnaire: {
        query: `
        mutation hrmUpdateRecruitQstmQuestionnaire($_eq: uuid = "", $_set: recruit_qstm_questionnaire_set_input = {}) {
            update_recruit_qstm_questionnaire(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                returning {
                    id
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_QUESTIONNAIRE_SURVEY"],
        function: [],
    },
    hrmUpdateRecruitRstbRecommenderPayment: {
        query: `
        mutation hrmUpdateRecruitRstbRecommenderPayment($_eq: numeric = "", $_set: recruit_rstb_recommender_payment_set_input = {}) {
            update_recruit_rstb_recommender_payment(_set: $_set, where: {id: {_eq: $_eq}}) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_CORE_RRM_ERP_PAYMENT"],
        function: [],
    },
    hrmUpdateConnectCstbEventParticipantStudentProgram: {
        query: `
        mutation hrmUpdateConnectCstbEventParticipantStudentProgram($_eq: uuid = "", $_set: connect_cstb_event_participant_set_input = {}) {
            update_connect_cstb_event_participant(where: {aggId: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmUpdateHrtbParticipant: {
        query: `
        mutation hrmUpdateHrtbParticipant($_eq: numeric = "", $_set: hrm_hrtb_participant_set_input = {}) {
            data: update_hrm_hrtb_participant(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
                returning {
                    aggId
                    code
                }
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_STUDENT"],
        function: [],
    },
    hrmInsertKstbGoalForUpdate: {
        query: `
        mutation hrmInsertKstbGoalForUpdate($objects1: [kpi_kstb_goal_insert_input!] = [], $objects2: [kpi_kstb_goal_assignment_insert_input!] = [], $objects3: [kpi_kstb_assignment_history_insert_input!] = []) {
            insert_kpi_kstb_goal(objects: $objects1) {
                affected_rows
            }
            insert_kpi_kstb_goal_assignment(objects: $objects2) {
                affected_rows
            }
            insert_kpi_kstb_assignment_history(objects: $objects3) {
                affected_rows
            }
        }`,
        variables: ["objects1", "objects2", "objects3"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateKstbGoal: {
        query: `
        mutation hrmUpdateKstbGoal($_set: kpi_kstb_goal_set_input = {}, $_eq: numeric = "") {
            update_kpi_kstb_goal(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
    hrmUpdateKstbGoalAssignment: {
        query: `
        mutation hrmUpdateKstbGoalAssignment($_set: kpi_kstb_goal_assignment_set_input = {}, $_eq: numeric = "") {
            update_kpi_kstb_goal_assignment(where: {id: {_eq: $_eq}}, _set: $_set) {
                affected_rows
            }
        }`,
        variables: ["_eq", "_set"],
        screen: ["SCREEN_RRM_TASK"],
        function: [],
    },
};